// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { SPLMonitorModule } from "modules/workflows/Streamer/SPL/SPLMonitorModule";

@autoinject
export class StreamerSPLSettingsModal extends SettingsModal<SPLMonitorModule> {}
